export default "__VITE_ASSET__798a9b44__"